module.exports = __webpack_public_path__ + "static/media/cabinet-5.e984d3e2.webp";